<template>
    <div>
        <van-dialog v-model="show" title="" confirmButtonColor="#1989fa" show-cancel-button @confirm="onConfirm">
            <div class="symptom-wrapper">
                <div class="top">
                    <div class="top-lable">主诉症状：</div>
                    <div class="top-value">
                        <van-tag class="tag-item" size="large" plain closeable type="primary" @close="onRemove(item.code)"
                            v-for="(item, index) in symptomChildren.filter(item => selectSymptom.includes(item.code))"
                            :key="index">
                            {{ item.name }}
                        </van-tag>
                    </div>
                </div>
                <div class="search van-hairline--top-bottom">
                    <van-field class="field-custom" v-model="search" placeholder="请输入搜索" clearable type="text"/>
                </div>
                <div class="select">
                    <div class="select-group van-hairline--right">
                        <div :class="activeFather === index ? 'select-item-active' : ''" class="select-item"
                            v-for="(item, index) in filterSymptomData" :key="index" @click="activeFather = index">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="select-group">
                        <div :class="selectSymptom.includes(item.code) ? 'select-item-active' : ''" class="select-item"
                            v-for="(item, index) in (filterSymptomData[activeFather]?.children || []).filter(IT => IT.name.includes(search))"
                            :key="index" @click="onSelect(item.code)">
                            {{ item.name }}
                            <van-icon class="select-icon" name="success" v-if="selectSymptom.includes(item.code)" />
                        </div>
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: 'selectSymptom',
    props: {
        showSelectSymptom: {
            type: Boolean,
            default: false
        },
        symptomIds: {
            type: Array,
            default: () => ([])
        },
        symptomData: {
            type: Array,
            default: () => ([])
        },
        symptomChildren: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            selectSymptom: [],
            search: '',
            activeFather: 0
        }
    },
    computed: {
        show: {
            get() {
                return this.showSelectSymptom
            },
            set(value) {
                this.$emit("update:showSelectSymptom", value);
            }
        },
        filterSymptomData() {
            return this.symptomData.filter(it => it.name.includes(this.search) || it.children.some(IT => IT.name.includes(this.search)))
        }
    },
    methods: {
        onConfirm() {
            this.$emit("update:symptomIds", [...this.selectSymptom]);
        },
        onSelect(code) {
            if (this.selectSymptom.includes(code)) {
                this.onRemove(code)
            } else {
                this.selectSymptom.push(code)
            }
        },
        onRemove(code) {
            const index = this.selectSymptom.findIndex(item => item === code)
            if (index !== -1) {
                this.selectSymptom.splice(index, 1)
            }
        },
    },
    watch: {
        show: {
            handler(value) {
                if (value) {
                    this.selectSymptom = [...this.symptomIds]
                    this.search = ''
                }
            },
            immediate: true,
        },
    }
}
</script>
<style lang="scss" scoped>
.symptom-wrapper {
    overflow: hidden;
    font-size: 16px;
    padding-top: 20px;

    .top {
        padding: 10px;
        display: flex;

        .top-lable {}

        .top-value {
            margin-left: 5px;
            flex: 1;
            max-height: 20vh;
            overflow-y: auto;

            .tag-item {
                margin-right: 10px;
                margin-bottom: 8px;
                background: #eff3fb;
            }
        }
    }

    .search {
        padding: 10px 15px;

        .field-custom {
            border: 1px solid #e5e5e5;
            border-radius: 5px;
            padding-bottom: 5px !important;
            padding-top: 5px !important;
        }
    }

    .select {
        height: 30vh;
        display: flex;

        .select-group {
            flex: 1;
            overflow-y: auto;

            .select-item {
                text-align: center;
                padding: 8px 10px;
                cursor: pointer;
                position: relative;
            }

            .select-item-active {
                color: #1989fa;
            }

            .select-icon {
                position: absolute;
                top: 50%;
                right: 10px;
                transform: translateY(-50%);
            }
        }
    }
}
</style>